import React from 'react';
import LoadingAnimation from '../LoadingAnimation';
import { useDataLoaderNew } from 'data-loader';
import { Tag } from 'ui-builder';

type SmartTagsContextValue = {
  availableTags: Tag[],
  loaded: boolean,
};

const SmartTagsReactContext = React.createContext<SmartTagsContextValue>({
  availableTags: [],
  loaded: false,
});

export default function SmartTagsContext(
  props: {
    getTagsFunc: () => Promise<Tag[]>,
    children: React.ReactElement,
    dependencies?: any[],
  },
) {


  const { loading, data: availableTags , version} = useDataLoaderNew(
    props.getTagsFunc,
    {
      dependencies: props.dependencies || [],
    }
  );

  const contextValue = React.useMemo(
    () => ({
      availableTags: availableTags || [],
      loaded: !loading,
    }),
    [version],
  );

  if (!loading) {
    return (
      <SmartTagsReactContext.Provider
        value={contextValue}
      >
        {props.children}
      </SmartTagsReactContext.Provider>
    );
  } else {
    return <LoadingAnimation />;
  }
}

export function useSmartTagsContext() {
  return React.useContext(SmartTagsReactContext);
}

